import * as types from '../constants'

const initialState = {
    listOrder: [],
    orderDetail: {}
}

export default (state = initialState, action) => {
    switch(action.type) {
        case types.GET_ALL_ORDER:
            return {
                ...state,
                listOrder: action.payload
            }
        case types.GET_ORDER_DETAIL:
            return {
                ...state,
                orderDetail: action.payload
            }
        case types.CHANGE_STATUS_ORDER:
            return {
                ...state
            }
        default:
            return state;
    }
}